// extracted by mini-css-extract-plugin
export default {"howItWorks":"HowItWorksSection_howItWorks__SeCoQ","steps":"HowItWorksSection_steps__anUNM","step":"HowItWorksSection_step__fV3Bv","icon":"HowItWorksSection_icon__Zvh-5"};